(ns teamoesterreich.admin-mode.ui-helper.sms-block-edit-card
  (:require
    [teamoesterreich.util.helper :as h]                     ;;(h/event-value e)
    [reagent.core :as r]
    [reagent-material-ui.components :as mui]
    [teamoesterreich.util.log :as log]
    [teamoesterreich.admin-mode.data.text-block :as d-text-block]
    [teamoesterreich.view-state :as v-state]


    [reagent-material-ui.icons.done :refer [done]]
    [reagent-material-ui.icons.save :refer [save]]
    [reagent-material-ui.icons.edit :refer [edit]]
    [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
    ))


(defn get-templates [template-group]
  (when (not (and (get-in @v-state/app-state [:text-blocks (keyword template-group)]) (coll? (get-in @v-state/app-state [:text-blocks (keyword template-group)]))))
    (d-text-block/get-group-text-blocks template-group
                                        (fn [res] (swap! v-state/app-state assoc-in [:text-blocks (keyword template-group)] res)))))


(defn get-it [content on-save-fn & [{:keys [title subText additional-buttons on-cancel-fn template-group]}]]
  (let [!st (r/atom {:editor-content content :edit-mode false})
        !editor-mode (r/cursor !st [:edit-mode])
        !editor-content (r/cursor !st [:editor-content])

        template-group (or template-group "")
        !template (r/cursor !st [:template])
        !template-set (r/cursor !st [:template-set])
        !templates (r/cursor v-state/app-state [:text-blocks (keyword template-group)])
        _ (get-templates template-group)
        ]

    (fn []
      (let [line-ch? (not= content @!editor-content)
            templates (filter
                        (fn [[c v]]
                          (and
                            ;;TODO orgId
                            (not (false? (:toeTextBlock-active v)))
                            (or (nil? (:toeTextBlock-key v))(= (:toeTextBlock-key v) ""))
                            (= (:toeTextBlock-type v) "sms")))
                        @!templates)

            template_map (reduce (fn [c [k t]] (assoc c k t)) {} templates)
            ]
        [mui/card
         (when title
           [mui/card-header {:title title}]
           )
         [mui/card-content
          [mui/grid {:container  true
                     :direction  "row"
                     :error      (< (count (str (:userDocument-type @!st))) 1)
                     :justify    "space-between"
                     :spacing    2
                     :style      {:paddingRight "5px"}
                     :alignItems "flex-start"}


           (when (and @!editor-mode template-group (not (empty? templates)))
             [mui/grid {:container false :item true :xs 1  :md 6 :lg 6} " "])

           (when (and @!editor-mode template-group (not (empty? templates)))
             [mui/grid {:container false :item true :xs 6 :md 3}
              [mui/input-label {:style {:font-size "12px" }} "Vorlage "]
              [mui/select
               {:fullWidth true
                :value     (or @!template "")
                :onChange  (fn [e]
                             (let [v (h/event-value e)]
                               (swap! !st assoc
                                      :template v
                                      :template-set (if (= "" v) false true))))
                }
               (for [[k v]  templates]
                 ^{:key (str "template-" k)}
                 [mui/menu-item {:style {} :value k} (str (:toeTextBlock-name v))])
               ]
              ])
           (when (and @!editor-mode template-group (not (empty? templates)))
             (when template-group
               [mui/grid {:container false :item true :xs 4 :md 2}
                [mui/button
                 {:style     {:float "right"}
                  :color     "secondary"
                  :variant   "contained"
                  :title     "Vorlage verwenden"
                  :disabled  (not @!template-set)
                  :startIcon (r/as-element [done])
                  :onClick   (fn []
                               (let [tmpl (get template_map (get @!st :template))]
                                 ;(log/debug "use template " (clj->js (get @!st :template)) (clj->js template_map) (clj->js tmpl))
                                 (swap! !st assoc
                                        :editor-content (:toeTextBlock-content tmpl)
                                        :template-set false)
                                 ))
                  }
                 "verwenden"]]))

           [mui/grid {:container false :item true :xs 12 :lg 8}

            [mui/text-field {
                             :style      {:backgroundColor (if line-ch? "#ffd6d2" "#ffffff")}
                             :fullWidth  true
                             :multiline  true
                             :rowsMax    5
                             :disabled   (not @!editor-mode)
                             :label      ""
                             :onChange   (fn [e] (reset! !editor-content (h/event-value e)))
                             :error      (> (count @!editor-content) 160)
                             :helperText (if (> (count @!editor-content) 160)
                                           (str "Sms-Text Länge (" (count @!editor-content) ") länger als 160 Zeichen!")
                                           (str "Sms-Text Länge max: 160 Zeichen (dzt:" (count @!editor-content) ")"))
                             :value      @!editor-content
                             }]]
           ]]

         [mui/card-content
          (when subText
            [:span subText])]

         [mui/card-actions
          {:style {:marginTop "15px"}}
          (if @!editor-mode
            [mui/button {:variant   "contained"
                         :startIcon (r/as-element [keyboard-arrow-left])
                         :onClick   (fn []
                                      (when on-cancel-fn (on-cancel-fn @!editor-content))
                                      (swap! !st assoc :editor-content content :edit-mode false))
                         }
             "Abbrechen"]
            [mui/button {:variant   "contained"
                         :startIcon (r/as-element [edit])
                         :onClick   #(reset! !editor-mode true)
                         }
             "Bearbeiten"])

          (when @!editor-mode
            [mui/button {:variant   "contained"
                         :color     "primary"
                         :startIcon (r/as-element [save])
                         :onClick   (fn []
                                      (on-save-fn @!editor-content)
                                      (swap! !st assoc :editor-content content :edit-mode false))
                         }
             "Speichern"])

          (when (and (not @!editor-mode) additional-buttons)
            additional-buttons)

          ]

         ]
        )

      )))